const tsaCodes = new Set([
  'BOS', 'EWR', 'JFK', 'LGA', 'PHL', 'ABE', 'ACY', 'BUF', 'BDL', 'HPN', 'PWM', 'PVD',

  'ATL', 'BNA', 'BWI', 'CLT', 'MCO', 'MIA', 'MSY', 'AVL', 'CHA', 'GSO', 'CVG', 'JAN',
  'JAX', 'LEX', 'SDF', 'RDU', 'RIC', 'SRQ', 'TPA', 'TYS', 'VPS', 'ORF', 'PBI',

  'DTW', 'MSP', 'ORD', 'CLE', 'DSM', 'GRR', 'GRB', 'IND', 'MCI', 'MDT', 'MKE', 'ICT',

  'AUS', 'DFW', 'IAH', 'DAL', 'HOU', 'ELP', 'LIT',

  'PHX', 'TUS', 'LAS', 'STL',

  'DEN', 'LAX', 'PSP', 'SAN', 'SEA', 'SFO', 'SLC', 'ANC', 'BLI', 'OAK', 'OMA',
  'ONT', 'PDX', 'RDM', 'RNO', 'SMF', 'SJC', 'SNA', 'STS'
]);

export function isTSA(code: string): boolean {
  return tsaCodes.has(code.toUpperCase());
}
